// extracted by mini-css-extract-plugin
module.exports = {"noreviewsCount":"ProviderReviewSummary_noreviewsCount__QMor2","noReviews":"ProviderReviewSummary_noReviews__E10_I","reviewTextColor":"ProviderReviewSummary_reviewTextColor__3R_cu"};